import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/Topic@4x.png'
import _imports_1 from '../assets/MongKok@4x.png'
import _imports_2 from '../assets/Agenda@4x.png'


const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "hello" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "activity" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "activity" }, "Please select your preferred session:", -1)),
      _createVNode(_component_router_link, {
        class: "activity",
        to: "/hkkf/froms?Session=7"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }, null, -1)
        ])),
        _: 1,
        __: [0]
      }),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "activity" }, [
        _createElementVNode("img", {
          src: _imports_2,
          alt: ""
        })
      ], -1))
    ])
  ]))
}